// @flow
import i18n from "i18next";
import k from "src/i18n/keys";

import React from "react";

import { TableHeader } from "./styles";
import { Th } from "src/styles/table";
import HeaderCheckbox from "./Row/HeaderCheckbox";

type Props = {
  sort: string,
  ascending: boolean,
  sortBy: Function,
};

const Header = ({ sort, ascending, sortBy }: Props) => {
  const getArrow = (element: string) => {
    if (element === sort) {
      if (ascending) {
        return <> {i18n.t(k._28)}</>;
      }
      return <> {i18n.t(k._29)}</>;
    }
  };
  return (
    <TableHeader>
      <tr>
        <Th tabIndex="0" active={sort === "title"}>
          <HeaderCheckbox>
            <span
              onClick={() => sortBy("title")}
              onKeyPress={() => sortBy("title")}
              role="button"
            >
              {i18n.t(k.PROCESS_NAME)}
              {getArrow("title")}
            </span>
          </HeaderCheckbox>
        </Th>
        <Th
          onClick={() => sortBy("activeCount")}
          onKeyPress={() => sortBy("activeCount")}
          role="button"
          tabIndex="0"
          active={sort === "activeCount"}
        >
          {i18n.t(k.ACTIVE_INSTANCES)}
          {getArrow("activeCount")}
        </Th>
        <Th
          onClick={() => sortBy("invocationCount")}
          onKeyPress={() => sortBy("invocationCount")}
          role="button"
          tabIndex="0"
          active={sort === "invocationCount"}
        >
          {i18n.t(k.TOTAL_INSTANCES)}
          {getArrow("invocationCount")}
        </Th>
        <Th
          onClick={() => sortBy("createdAt")}
          onKeyPress={() => sortBy("createdAt")}
          role="button"
          tabIndex="0"
          active={sort === "createdAt"}
        >
          {i18n.t(k.CREATED_AT)}
          {getArrow("createdAt")}
        </Th>
        <Th
          onClick={() => sortBy("updatedAt")}
          onKeyPress={() => sortBy("updatedAt")}
          role="button"
          tabIndex="0"
          active={sort === "updatedAt"}
        >
          {i18n.t(k.UPDATED_AT)}
          {getArrow("updatedAt")}
        </Th>
        <Th
          onClick={() => sortBy("creator")}
          onKeyPress={() => sortBy("creator")}
          role="button"
          tabIndex="0"
          active={sort === "creator"}
        >
          {i18n.t(k.CREATED_BY2)}
          {getArrow("creator")}
        </Th>
      </tr>
    </TableHeader>
  );
};

export default Header;
